var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddressBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 10.6185C9.69962 10.6242 9.40088 10.57 9.12148 10.459C8.84208 10.3479 8.58762 10.1823 8.37299 9.97174C8.15836 9.76119 7.98787 9.50996 7.87148 9.23274C7.75509 8.95553 7.69514 8.65788 7.69514 8.35722C7.69514 8.05656 7.75509 7.75892 7.87148 7.4817C7.98787 7.20449 8.15836 6.95326 8.37299 6.74271C8.58762 6.53216 8.84208 6.36652 9.12148 6.25547C9.40088 6.14443 9.69962 6.0902 10.0002 6.09597C10.5924 6.10734 11.1565 6.35058 11.5713 6.77341C11.9861 7.19624 12.2185 7.76491 12.2185 8.35722C12.2185 8.94954 11.9861 9.51821 11.5713 9.94104C11.1565 10.3639 10.5924 10.6071 10.0002 10.6185ZM8.23022 0.864308C4.67189 1.65847 2.17689 5.00764 2.31689 8.65097C2.42689 11.5126 4.18272 14.0726 9.40689 19.0951C9.73689 19.4118 10.2652 19.4135 10.5961 19.096C15.9994 13.9018 17.6927 11.3418 17.6927 8.35681C17.6927 3.53181 13.2486 -0.255692 8.23022 0.865141",
    fill: "#414B56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddressBlack);
export default __webpack_public_path__ + "static/media/icon_address_black.7dc84126ca8129bf1db8f7db5548c554.svg";
export { ForwardRef as ReactComponent };